module.exports = __webpack_public_path__ + "img/daphne.34449837.jpg";